/**************************************************
 * Nombre:       IconoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../../Tema";


const IconoTexto = ({Icono, texto}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={1} sx={{justifyContent: 'flex-start'}}>
                <Icono sx={{fill: theme.palette.primary.main}} />
            </Grid>

            <Grid container size={11} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontWeight: 300}} >{texto}</Typography>
            </Grid>

        </Grid>
    )

}
export default IconoTexto